<template>
  <el-dialog
    :visible="visible"
    title="Senha gerada"
    width="440px"
    center
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <p>Envie os dados de acesso ao usuário.</p>
    <el-input type="textarea" :rows="3" :value="text" readonly></el-input>
    <span slot="footer">
      <el-button type="primary" icon="el-icon-document-copy" @click="copy">Copiar</el-button>
      <el-button @click="$emit('close')">Fechar</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "PasswordCreatedDialog",
  props: {
    visible: Boolean,
    username: String,
    password: String,
  },
  computed: {
    text() {
      return `Acesso: ${window.location.origin}\nLogin: ${this.username}\nSenha: ${this.password}`;
    },
  },
  methods: {
    copy() {
      this.$copyText(this.text).then(() =>
        this.$message({ type: "success", message: "Dados de acesso copiados!" })
      );
    },
  },
};
</script>
